import React from 'react';

/* WEB-31 (заявка владельца 12.09): кнопка отправки живёт ВНУТРИ строки ввода и
   появляется, когда есть что отправлять. Вариант А разбора: скрепка остаётся
   на своём месте — иначе прикрепить файл к УЖЕ набранному тексту стало бы
   нельзя (вариант «скрепка сменяется отправкой», как в Telegram, отвергли
   именно поэтому).

   🔴 Компонент общий на все три композера (1:1 владельца, комната, участник)
   СПЕЦИАЛЬНО: правило появления одно, и разъехаться трём копиям негде.

   Появление и гашение — РАЗНЫЕ вещи, и решают их РАЗНЫЕ величины:
   - ПОЯВЛЕНИЕ решает содержимое: есть текст или файл (либо файл уже уехал на
     сервер и идёт загрузка) → кнопка есть; нет ничего → кнопки нет вовсе, и в
     табуляции её тоже нет;
   - ГАШЕНИЕ решает состояние: отправка запрещена, идёт загрузка, чат не готов
     → кнопка видна и погашена, рядом с объяснением.

   🔴 Ревью 12.09 поймало противоречие в ПОСТАНОВКЕ: «появляется при наличии
   содержимого» и «при запрете видна и погашена» спорят на пустом поле. Выбран
   первый: на пустом поле отправлять нечего, и погашенная кнопка была бы шумом.
   Объяснение при этом не остаётся без адресата — у запрета своя плашка со
   своей кнопкой «Отправить всё равно» (`SendBlocked`), она видна независимо.
   Загрузка — не исключение из правила, а его случай: файл УЖЕ содержимое, он
   в эту секунду уезжает на сервер. */
export default function SendButton({
  text, file, ready, sendStopped, uploading, onSend, inputRef,
}) {
  const hasPayload = Boolean(String(text ?? '').trim() || file);
  const visible = hasPayload || Boolean(uploading);

  /* Слот стоит ВСЕГДА, даже пустой: он держит ширину, и поле ввода не дёргается
     на первой набранной букве. */
  return (
    <span className="msgSendSlot" data-testid="send-slot">
      {visible && (
        <button
          type="button"
          className="msgSendBtn"
          /* 🔴 Доступное имя — слово, а не глиф: его читает голосовой доступ, по
             нему же адресуются пины и живые сценарии. Иконка для них невидима. */
          aria-label="Отправить"
          title="Отправить"
          disabled={!ready || Boolean(sendStopped) || Boolean(uploading) || !hasPayload}
          /* 🔴 После отправки поле пустеет, кнопка исчезает — и фокус вместе с
             ней уезжает НА ВЕСЬ ДОКУМЕНТ (ревью 12.09: active=BODY). Человек
             на клавиатуре терял место, а на телефоне закрывалась клавиатура.
             Возвращаем фокус в поле — там же, где он был бы после Enter. */
          onClick={() => {
            onSend();
            inputRef?.current?.focus();
          }}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
            <path
              d="M12 19V6M12 6l-5.5 5.5M12 6l5.5 5.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </span>
  );
}
